import styled from 'styled-components';

import { Container } from 'Components/core'

export default styled(Container).attrs(props => ({
  column: props.column || true
}))`
  padding: 32px;
  margin: auto;
  margin-top: -32px;
  align-items: flex-start;
  z-index: 2;
  background-color: #fff;
  width: 90%;
`;
